function calc_values() {
  let ftl = document.getElementById("feetlength").value;
  let ftw = document.getElementById("feetwidth").value;
  let fth = document.getElementById("thickness").value;
  let tcy = ((ftl * ftw * fth) / 27).toFixed(2);
  let t1cb = Math.ceil(tcy * 27).toFixed(0);
  let t2cb = Math.ceil(tcy * 13.5).toFixed(0);
  let t15cb = Math.ceil(t1cb / 1.5).toFixed(0);
  let t3cb = Math.ceil(t1cb / 3).toFixed(0);
  let t25qb = Math.ceil(tcy * 25.71404638).toFixed(0);
  let t50qb = Math.ceil((tcy * 25.71404638) / 2).toFixed(0);

  if (tcy == 0) {
    if (ftl * ftw * fth > 0) {
      tcy = 0.01;
      t1cb = 1;
      t15cb = 1;
      t2cb = 1;
      t3cb = 1;
      t25qb = 1;
      t50qb = 1;
    }
  }

  document.getElementById("total3cubags").innerHTML = t3cb;
  document.getElementById("total15cubags").innerHTML = t15cb;
  document.getElementById("total2cubags").innerHTML = t2cb;
  document.getElementById("totalcufeet").innerHTML = t1cb;
  document.getElementById("totalcuyards").innerHTML = tcy;
  document.getElementById("total25qbags").innerHTML = t25qb;
  document.getElementById("total50qbags").innerHTML = t50qb;
}

const form = document.getElementById("calculator");
form.addEventListener("reset", function () {
  let tcy = "0.00";
  let t25qb = 0;
  let t50qb = 0;
  let t15cb = 0;
  let t3cb = 0;
  let t2cb = 0;
  let t1cb = 0;
  document.getElementById("total25qbags").innerHTML = t25qb;
  document.getElementById("total50qbags").innerHTML = t50qb;
  document.getElementById("total3cubags").innerHTML = t3cb;
  document.getElementById("total15cubags").innerHTML = t15cb;
  document.getElementById("total2cubags").innerHTML = t2cb;
  document.getElementById("totalcufeet").innerHTML = t1cb;
  document.getElementById("totalcuyards").innerHTML = tcy;
});


function convert() {
  // Get the value of cubic yards input
  var cubicYards = parseFloat(document.getElementById("cubicYards").value);

  // Perform the conversion to pounds
  var pounds = cubicYards * 1350; // You can adjust the conversion factor accordingly

  // Perform the conversion to tons
  var tons = cubicYards * 0.675; // You can adjust the conversion factor accordingly

  // Display the results
  document.getElementById("resultPounds").innerHTML = "" + pounds.toFixed(2);
  document.getElementById("resultTons").innerHTML = "" + tons.toFixed(2);
}